import React from 'react';
import { StaticPageLayout } from '../StaticPageLayout';
import styles from '../StaticPageLayout.module.scss';
import {
  CONTACT_EMAIL,
  CONTACT_MAILTO,
  COMPANY_SHORT_NAME,
  COMPANY_STREET,
  COMPANY_CITY,
  COMPANY_COUNTRY,
} from '../../../utils/contactInfo';

export const Impressum: React.FC = () => {
  return (
    <StaticPageLayout title="Impressum">
      <div className={styles.contentWrapper}>
        <h2>Angaben gemäß § 5 TMG</h2>
        <p>
          {COMPANY_SHORT_NAME}<br />
          {COMPANY_STREET}<br />
          {COMPANY_CITY}<br />
          {COMPANY_COUNTRY}
        </p>

        <h2>Kontakt</h2>
        <p>
          E-Mail: <a href={CONTACT_MAILTO}>{CONTACT_EMAIL}</a>
        </p>

        <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
        <p>
          {COMPANY_SHORT_NAME}<br />
          {COMPANY_STREET}, {COMPANY_CITY}
        </p>

        <h2>Streitschlichtung</h2>
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
          <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer">
            https://ec.europa.eu/consumers/odr/
          </a>
          .<br />
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>

        <h2>Haftung für Inhalte</h2>
        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten
          nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
          Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
          Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
          Tätigkeit hinweisen.
        </p>
      </div>
    </StaticPageLayout>
  );
};
